module.exports = __webpack_public_path__ + "static/sys_ph09-61f53d75a1cc07b44691fd1e90460f32.jpg";